/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAdviserDto = {
    /**
     * Updated first name for the adviser user
     */
    firstName?: string;
    /**
     * Updated last name for the adviser user
     */
    lastName?: string;
    /**
     * Updated email address for the adviser user (also updates Auth0 for login-capable users; AUTHORISED_REP is contact-only and may share emails with other AUTHORISED_REP users)
     */
    emailAddress?: string;
    /**
     * Updated adviser FSPR number
     */
    fsprNumber?: string;
    /**
     * Updated FAP UUID for this adviser (SUPER_ADMIN only)
     */
    fapId?: string;
    /**
     * Updated adviser role classification (SUPER_ADMIN only). Moving off AUTHORISED_REP enables portal login (unblocks or creates the Auth0 user); moving to AUTHORISED_REP blocks it.
     */
    adviserRole?: UpdateAdviserDto.adviserRole;
    /**
     * Login password, only used when changing an AUTHORISED_REP to a login-capable adviser role. Required when the adviser has no existing Auth0 login. Must contain at least 8 characters with a lowercase letter, an uppercase letter and a number.
     */
    password?: string;
    /**
     * Adviser commission percentage. Send null to clear the adviser override and inherit from the FAP
     */
    commissionPercentage?: number | null;
    /**
     * Adviser override percentage. Send null to clear the adviser override and inherit from the FAP
     */
    overridePercentage?: number | null;
    /**
     * Override recipient name
     */
    overrideName?: string;
    /**
     * Adviser broker fee percentage
     */
    brokerFeePercentage?: number;
    /**
     * Quoting adviser new business commission percentage. Send null to clear the adviser override and inherit from the FAP
     */
    qaCommissionPercentage?: number | null;
    /**
     * Quoting adviser renewal commission percentage. Send null to clear the adviser override and inherit from the FAP
     */
    qaRenewalCommissionPercentage?: number | null;
};
export namespace UpdateAdviserDto {
    /**
     * Updated adviser role classification (SUPER_ADMIN only). Moving off AUTHORISED_REP enables portal login (unblocks or creates the Auth0 user); moving to AUTHORISED_REP blocks it.
     */
    export enum adviserRole {
        AUTHORISED_REP = 'AUTHORISED_REP',
        QUOTING_ADVISER = 'QUOTING_ADVISER',
        INTERNAL_ADVISER = 'INTERNAL_ADVISER',
    }
}

